
import './App.css';
import Europe from './Pages/Europe';
import Japan from './Pages/Japan';
import { Route, Routes } from "react-router-dom";
import Romania from './Pages/Romania';

function App() {
  
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={ <Europe/> } />
        <Route path="/eu" element={ <Europe/> } />
        <Route path="/jp" element={ <Japan/> } />
        <Route path="/ro" element={ <Romania />} />
      </Routes>
    </div>
  );
}

export default App;
